import ApiService from '../_api/api.service'
import JwtService from './jwt.service'

// Many pages ask the API nothing that checks the session, so a user whose session ended
// (deactivated, deleted, password changed elsewhere) would stay on them. One request per full
// page load finds out: its 401 goes through the interceptor in api.service.js, which clears
// the stored user and loads the login page. The answer is not used, and any other failure says
// nothing about the session: it logs nobody out and shows no toast.
export const checkSessionOnLoad = router => {
  router.onReady(() => {
    if (!JwtService.getToken()) return
    // Its message may say the card was charged, so a 401 must not take the user away before
    // reading it. A successful payment refreshes the user there, which checks the session too
    if (router.currentRoute.name === 'paymentResult') return
    ApiService.query('/user/current', { silent: true }).catch(() => {})
  })
}
